module.exports = __webpack_public_path__ + "static/media/home.d8b57e64.svg";